import { em, rem } from 'polished';

export const toEM = (px) => em(`${px}px`);
export const toRem = (px) => rem(`${px}px`);
